import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Import components
import Header from './components/Header';
import Footer from './components/Footer';

// Import pages
import Home from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Testimonials from './pages/Testimonials';
import AdminUtility from './pages/AdminUtility';
import DemoPage from './pages/DemoPage';

// Placeholder component for pages that haven't been created yet
const Placeholder = ({ title }) => (
  <div className="pt-32 px-4 min-h-screen">
    <div className="container mx-auto max-w-4xl text-center">
      <div className="inline-block p-8 rounded-lg bg-white shadow-md">
        <h1 className="text-3xl font-bold mb-4 text-gray-900">{title} Page</h1>
        <p className="text-lg text-gray-600">This page is under construction.</p>
      </div>
    </div>
  </div>
);

// Scroll to top component - ensures page starts at top when navigating
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Header />
        
        <ScrollToTop />
        
        {/* Main content */}
        <main className="flex-grow pt-24">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/admin" element={<AdminUtility />} />
            {/* Add a catch-all route */}
            <Route path="*" element={<Placeholder title="404 - Page Not Found" />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
